import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { get } from 'lodash';

import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import MultilineEllipsisText from 'rebook/apps/base/components/MultilineEllipsisText';
import BookReadButton from 'rebook/apps/books/components/BookReadButtonNonRent';
import { Book } from 'rebook/apps/books/models';
import { Author } from 'rebook/apps/catalog/models';
import pluralize from 'rebook/apps/utils/text/pluralize';
import BookRating from 'rebook/apps/books/components/BookRating';

import styles from './style.scss';


const BookCardHeader = ({ book, withAuthor, user, theme, height = 100, width = 60, withButton, GACategory }) => {
  const theBook = new Book(book);
  const theAuthor = book && new Author(book.main_author);
  const availableForUser = theBook.available_for_user;
  const isAudiobook = get(book, 'type', '') === 'audio';

  // если пользователю недоступна книга или книга доступна, но у нее нет пробного фрагмента
  const unavailableBookNoPreview = !availableForUser || (!availableForUser && !theBook.preview);
  const readLink = (user && !unavailableBookNoPreview) ? '' : theBook.getFragmentUrl();

  return (
    <div className={classNames(styles.content, styles[`${theme}Theme`])}>
      <div className={styles.book}>
        {book && (
          <React.Fragment>
            <div className={styles.image}>
              <Link to={theBook.getLink()}>
                {theBook.default_cover && (
                  <CroppedImage
                    width={width}
                    height={height}
                    src={theBook.default_cover}
                    alt={theBook.name} />
                )}
              </Link>
            </div>
            <div className={styles.text}>
              <div className="title-3">
                <Link to={theBook.getLink()}>
                  <MultilineEllipsisText maxLinesCount={2}>{theBook.name}</MultilineEllipsisText>
                </Link>
              </div>
              {withAuthor && theBook.main_author && (
                <Link to={theAuthor.getLink()}>
                  <div className={classNames(styles.author, 'link')}>
                    {theBook.main_author.cover_name}
                  </div>
                </Link>
              )}
              <div className={styles.bookInformationRating}>
                <div
                  className={classNames(styles.bookRating, 'jest-book-rating-header')}
                  itemProp="aggregateRating"
                  itemScope
                  itemType="http://schema.org/AggregateRating">
                  <React.Fragment>
                    <meta itemProp="ratingCount" content={book.rating.votes} />
                    <meta itemProp="ratingValue" content={book.rating.rating} />
                    <meta itemProp="bestRating" content="5" />
                    <meta itemProp="worstRating" content="0" />
                    <div itemProp="itemReviewed" itemScope itemType="http://schema.org/Product" />
                  </React.Fragment>
                  <BookRating value={book.rating.rating} />
                  <span className={styles.bookRatingCount}>
                    {book.rating.rating.toPrecision(2).replace('.', ',')}
                  </span>
                </div>
                <div className={styles.bookReaderCount}>
                  {book.rating.votes || 0}&nbsp;
                  {pluralize(book.rating.votes, 'читатель оценил', 'читателя оценили', 'читателей оценили')}
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
      {withButton && (
        <div className={styles.button}>
          <BookReadButton
            link={readLink}
            book={theBook}
            extraClassName="jest-book-card-header-link-to-book"
            GACategory={GACategory}
            isReaderUnavailable={unavailableBookNoPreview}>
            {isAudiobook ? 'Слушать онлайн' : 'Читать онлайн'}
          </BookReadButton>
        </div>
      )}
      <Link to={theBook.getLink()} className={styles.arrow} />
    </div>
  );
};

BookCardHeader.propTypes = {
  book: PropTypes.object.isRequired,
  coverName: PropTypes.string,
  theme: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  withAuthor: PropTypes.bool,
  withButton: PropTypes.bool,
  GACategory: PropTypes.string,
};

export default BookCardHeader;
